import { Role } from "./role.model";

/**
 * Sections of the merchant analytics dashboard (/dashboard) and the Keycloak realm roles that unlock
 * each one (any of). Same table as the backends' `MerchantMetricsAccess` role maps (one copy per
 * service, each asserted by a unit test): the API enforces it, the UI only uses it to decide who may
 * open the page.
 */
export const METRICS_SECTION_ROLES = {
  CONVERSATIONS: [Role.TEAM_INBOX, Role.CONVERSATION_VIEW, Role.ANALYTICS_CHAT],
  CONVERSATIONS_ROWS: [Role.TEAM_INBOX, Role.CONVERSATION_VIEW],
  CAMPAIGNS: [Role.BROADCAST, Role.BROADCAST_VIEW, Role.BROADCAST_HISTORY],
  TEMPLATES: [Role.MANAGE_TEMPLATE, Role.WORKFLOW_VIEW],
  CONTACTS: [Role.MANAGE_CONTACT, Role.CONTACT_VIEW],
  ORDERS: [Role.ORDERS, Role.ORDERS_VIEW],
  CATALOG: [Role.PRODUCT, Role.PRODUCT_VIEW, Role.ORDERS, Role.ORDERS_VIEW],
  PAYMENTS: [
    Role.PAYMENT_VIEW,
    Role.MANAGE_PAYMENT_AUTHZ,
    Role.MANAGE_PAYMENT_LINK,
    Role.MANAGE_SAVED_CARDS,
    Role.MANAGE_PAYMENT_SCHEDULES,
  ],
  TICKETS: [Role.MANAGE_TICKET, Role.TICKET_VIEW],
  TEAM: [Role.MANAGE_AGENT, Role.MANAGE_AGENT_GROUP],
  USERS: [Role.AUDIT_MANAGE],
} as const satisfies Record<string, readonly Role[]>;

export type MetricsSection = keyof typeof METRICS_SECTION_ROLES;

/** Anyone holding one of these roles may open /dashboard (ANALYTICS_CHAT + every section role, roleMode "any"). */
export const MERCHANT_DASHBOARD_ROLES: readonly string[] = [
  ...new Set<string>([Role.ANALYTICS_CHAT, ...Object.values(METRICS_SECTION_ROLES).flat()]),
];
